<template>
    <div>
        <div class="new_top">
            <div class="ac_one">
                <div class="ac_title">
                    1.全站-新游戏-上线，游戏内更新自助转区插件，<span>储值兑换赠送100%转区点</span>（详情查阅官网或咨询平台客服）<br>
                    2.新上线的游戏，角色绑定会员等级，等级越高爆率加成越高！
                </div>
                <div class="ac_box">
                    <div class="ac_text">
                        平台日常活动+转区点 玩家兑换<b>倍率高达60倍!</b><br>
                        活动时间:5月6日起<br>
                        活动内容:活动期间充值任何额度，即可赠送等额转区点<br>
                        充值100 充值倍率24倍+赠100%转区点 <b>总倍率48倍</b><br>
                        充值200 充值倍率25倍+赠100%转区点 <b>总倍率50倍</b><br>
                        充值300 充值倍率26倍+赠100%转区点 <b>总倍率52倍</b><br>
                        充值500 充值倍率28倍+赠100%转区点 <b>总倍率56倍</b><br>
                        充值1000 充值倍率30倍+赠100%转区点 <b>总倍率60倍</b>
                    </div>
                    <!-- 背景 -->
                    <img class="rule_bg" src="/activity/2025labourDay/img/rule.png?v=1">
                </div>
                
                <img class="djcz_btn btn_hover" src="/activity/2025labourDay/img/djcz.png?v=1" @click="toReach">
                <div class="beizhu">
                    <div class="ac_bz">活动期间，新服基础爆率提高100%，心动不如行动，快来体验吧！</div>
                    <!-- 背景 -->
                    <img class="time_bg" src="/activity/2025labourDay/img/time.png?v=1">
                </div>
            </div>
            <!-- 背景 -->
          <img class="bg" src="/activity/2025labourDay/img/bg.png?v=1">
        </div>
    </div>
</template>

<script>
export default {
    name: '2025labourDay',
    data() {
      return {
        isClick: true, //防抖
        isactive:false, //活动是否开启
        money:'',
        bag_num:0,
      }
    },
    methods: {
        toReach(){
            this.$router.push({
                path:'/member/wallet'
            })
        },
    },
    created(){
    }
}
</script>

<style scoped >
.beizhu{
    position: relative;
    margin-top: 18px;
}
.time_bg{
    width: 631px;
}
.new_top{
    padding-top: 395px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    left: 0;
    top: 0;
}
.bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -99;
    width: 100%;
}
.ac_one{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 19%;
}
.ac_title{
    position: relative;
    left: 14%;
    font-family: Source Han Sans SC;
    font-weight: 500;
    font-size: 18px;
    color: #006CCA;
    text-shadow: 
    -1px -1px 0 #FFFAE8,  
    1px -1px 0 #FFFAE8,
    -1px 1px 0 #FFFAE8,
    1px 1px 0 #FFFAE8;
}
.ac_title span{
    color: #BE272E;
}
.ac_box{
    position: relative;
    margin-top: 60px;
}
.ac_text{
    font-family: Source Han Sans SC;
    font-weight: 500;
    font-size: 18px;
    color: #006CCA;
    text-shadow: 
    -1px -1px 0 #FFFAE8,  
    1px -1px 0 #FFFAE8,
    -1px 1px 0 #FFFAE8,
    1px 1px 0 #FFFAE8;
}
.ac_text b{
    color: #EA1E28;
  }
.rule_bg{
    width: 678px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -2;
}
.ac_bz{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 22px;
    background: linear-gradient(0deg, #00FFFF 0%, #FFFFFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    width: 100%;
}
.djcz_btn{
    margin-top: 30px;
    width: 246px;
}

</style>